import React from 'react';
import clsx from 'clsx';
import Link from 'next/link';
import { useOpenHandler } from '~/hooks/useOpenHandler';
import Styles from './CompanySettingList.module.scss';
import type { CompanySettingWithItemSetting } from '~/models/CompanySetting';
import { getItemSettingLength } from '~/models/CompanySetting';
import { PATH as CONSTRUCTION_ITEM_SETTING_PATH } from '~/pages/vendors/settings/company_settings/[companyMasterId]/construction_item_settings';
import { useSessions } from '~/hooks/vendors/useSessions';
import { VendorManagementCompanySettingModal } from './vendor_management_company_settings/VendorManagementCompanySettingModal';

type Props = {
  companySetting: CompanySettingWithItemSetting;
};

export const CompanySettingListRow: React.FC<Props> = ({
  companySetting
}: Props) => {
  const { data: session } = useSessions().index();
  const { isOpen, handleOpen, handleClose } = useOpenHandler();
  const ItemSettingLength = React.useMemo((): number => {
    const itemSettings = companySetting.constructionItemSettings;
    if (itemSettings === null || session === null) {
      return 0;
    }
    return getItemSettingLength(itemSettings, session.vendorCompany.id);
  }, [companySetting.constructionItemSettings, session]);
  return (
    <tr className={clsx(Styles.ListRow)}>
      <td className={clsx(Styles.ListCol, Styles.SpCol)}>
        <div className={Styles.Name}>{companySetting.name}</div>
      </td>
      <td className={clsx(Styles.ListCol, Styles.PcCol)}>
        {companySetting.name}
      </td>
      <td className={clsx(Styles.ListCol, Styles.Edit)}>
        <a
          className={Styles.EditLink}
          href="#"
          onClick={(e: React.MouseEvent): void => {
            e.preventDefault();
            handleOpen();
          }}
        >
          編集
        </a>
        <VendorManagementCompanySettingModal
          companySetting={companySetting}
          handleClose={handleClose}
          isOpen={isOpen}
        />
      </td>
      <td className={clsx(Styles.ListCol, Styles.Edit)}>
        <Link
          className={Styles.EditLink}
          href={CONSTRUCTION_ITEM_SETTING_PATH(companySetting.companyMasterId)}
        >
          単価一覧
        </Link>
        <span className={Styles.ConstructionItemNumberTag}>
          {ItemSettingLength}件設定中
        </span>
      </td>
    </tr>
  );
};
